// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2061":"2aab3835","6642":"a446c581"}[chunkId] + ".chunk.css";
};